import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getCustomerById } from "../../api/apiCustomers";

export const useGetCustomerById = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["customer", id, i18next.language],
        queryFn: () => getCustomerById(id),
        enabled: !!id,
        retry: false,
    });

    return {
        customer: data?.data || null,
        isLoading,
        error,
        refetch,
    };
};
